(function() {
    window.closeChildWindow = function(childWindow) {
        childWindow.close();
    };

    $(document).ready(function() {
        $('a.closeBackTab').on('click', function(e) {
            e.preventDefault();
            window.open($(this).attr('href') + '#autoClose', '');
        });
        if (window.location.hash === '#autoClose' && window.opener !== null) {
            history.replaceState(null, null, '#closeCurrentTab');
            history.pushState(null, null, '#');

            window.setInterval(function() {
                if (window.location.hash == '#closeCurrentTab') {
                    window.opener.closeChildWindow(window);
                }
            }, 300);
        }
    });
})();
